import React from "react";

import { Col, InputMasked, Row, Typography } from "components";

export const ProfileUpdateHidden = ({ details, t }) => (
  <>
    <Row className="margin-top-400">
      <Col>
        <Typography variant="h2">{t("profileUpdate.hiddenData.title")}</Typography>
      </Col>
    </Row>
    <Row className="margin-top-200">
      <Col sm={24} md={12}>
        <InputMasked
          name="birthYear"
          label={t("profileUpdate.hiddenData.inputs.birthYear")}
          rules={[{ required: false }]}
          initialValue={details.birthYear}
          mask="0000"
          placeholder="YYYY"
        />
      </Col>
      <Col sm={24} md={12}>
        <InputMasked
          name="phone"
          label={t("profileUpdate.hiddenData.inputs.phone")}
          rules={[{ required: true }]}
          initialValue={details.phone}
          placeholder={t("profileUpdate.hiddenData.inputs.phonePlaceholder")}
          mask="+00 00 000000[000]"
        />
      </Col>
    </Row>
  </>
);
